/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { UsersApiService } from './services/users-api.service';
import { UserSettingsApiService } from './services/user-settings-api.service';
import { SubDoctorsApiService } from './services/sub-doctors-api.service';
import { ActingAsApiService } from './services/acting-as-api.service';
import { AppointmentApiService } from './services/appointment-api.service';
import { SpecialtyApiService } from './services/specialty-api.service';
import { ProvinceApiService } from './services/province-api.service';
import { CenterApiService } from './services/center-api.service';
import { AppointmentReasonApiService } from './services/appointment-reason-api.service';
import { IndustryApiService } from './services/industry-api.service';
import { PositionApiService } from './services/position-api.service';
import { UserAcceptTermsApiService } from './services/user-accept-terms-api.service';
import { WorkplacesApiService } from './services/workplaces-api.service';
import { SchedulesApiService } from './services/schedules-api.service';
import { TaxCountriesApiService } from './services/tax-countries-api.service';
import { ChatApiService } from './services/chat-api.service';
import { NotificationsApiService } from './services/notifications-api.service';
import { PlansApiService } from './services/plans-api.service';
import { UserBillingApiService } from './services/user-billing-api.service';
import { StripeWebhookApiService } from './services/stripe-webhook-api.service';
import { SubscriptionApiService } from './services/subscription-api.service';
import { SubscriptionInvoicesApiService } from './services/subscription-invoices-api.service';
import { TermsAndConditionsApiService } from './services/terms-and-conditions-api.service';
import { SubscriptionPeriodsApiService } from './services/subscription-periods-api.service';
import { VisitorBlocksApiService } from './services/visitor-blocks-api.service';
import { QualiPassApiService } from './services/quali-pass-api.service';
import { QualiPassPresenceApiService } from './services/quali-pass-presence-api.service';
import { PasskeysApiService } from './services/passkeys-api.service';
import { CouriersApiService } from './services/couriers-api.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    UsersApiService,
    UserSettingsApiService,
    SubDoctorsApiService,
    ActingAsApiService,
    AppointmentApiService,
    SpecialtyApiService,
    ProvinceApiService,
    CenterApiService,
    AppointmentReasonApiService,
    IndustryApiService,
    PositionApiService,
    UserAcceptTermsApiService,
    WorkplacesApiService,
    SchedulesApiService,
    TaxCountriesApiService,
    ChatApiService,
    NotificationsApiService,
    PlansApiService,
    UserBillingApiService,
    StripeWebhookApiService,
    SubscriptionApiService,
    SubscriptionInvoicesApiService,
    TermsAndConditionsApiService,
    SubscriptionPeriodsApiService,
    VisitorBlocksApiService,
    QualiPassApiService,
    QualiPassPresenceApiService,
    PasskeysApiService,
    CouriersApiService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
